import { multiply, division, reduce, ceil, add } from '@/utils/math';

export const CHARGE_RATIO = 0; //0.008; // 默认手续费比例 0.4%
export const CHARGE_RATIO_PAY_TO_USER = 0; //0.006; // 默认手续费比例 0.4%
// 2022-09-21 由于支付限制最高6000元，这里最大数额改为6000(废弃)
// 2022-11-03 支付限制改成2万
export const MAX_PRICE = 20000; // 普通用户
export const MAX_PRICE_PAY_TO_USER = 20000; // 独立商户 + 付款到零钱

// 手续费金额 金额的计算price单位是分，返回的也是分
export const chargeComputed = (price, ratio) => {
	return amountComputed(price, ratio) - price;
};

window.division = division;
// 加上手续费的总金额
// 就是这样算的，虽然看着不对
export const amountComputed = (price, ratio) => {
	return ceil(division(price, reduce(1, ratio)));
};
